<template>
  <div>
    <template v-for="(item, index) in options">
      <template v-if="values.includes(item.type)">
        <a-tag v-if="color"
          :color="getColor(index)"
          :index="index">
          {{ item.name }}
        </a-tag>
        <span :index="index" v-else>
          {{ item.name }}
        </span>
      </template>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CustomDictTag',
  props: {
    options: {
      type: Array,
      default: null
    },
    value: {
      type: [Number, String, Boolean, Array],
      default: null
    },
    color: {
      type: [Boolean],
      default: false
    },
    colorArray: {
      type: Array,
      default: () =>{
        return ['green', 'blue', 'orange', 'purple', 'cyan', 'magenta', 'gold', 'lime', 'volcano'];
      }
    }
  },
  methods: {
    getColor(index) {
      //如果数组下标越界, 则返回green
      if (index > this.colorArray.length - 1) {
        return 'green'
      } else {
        return this.colorArray[index]
      }
    }
  },
  computed: {
    values () {
      if (this.value !== null && typeof this.value !== 'undefined') {
        return Array.isArray(this.value) ? this.value : [this.value]
      } else {
        return []
      }
    }
  }
}
</script>
